module.exports = __webpack_public_path__ + "static/media/freelance.ae85f535.jpg";